import { useEffect } from "react";

/**
 * Supply URLs for images which don't exist in the DOM initially but
 * are expected to be smoothly animated in.
 *
 * @param urls Must be readonly, value will be used as effect deps
 */
export const useImagePreload = (
  urls: () => Array<string>,
  deps: ReadonlyArray<unknown>
) => {
  useEffect(() => {
    urls().forEach((url) => {
      const img = new Image();
      img.src = url;
    });
    // This is why it's a ReadonlyArray
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
